import { z } from 'zod';

/**
 * The per-user AI seat classes (ADR-0027). The list is the same as `SEAT_KEYS`
 * of `@septima/feature-core`. The server checks the two lists at compile time.
 */
export const SESSION_SEAT_KEYS = ['ops-ai', 'im-ai', 'compliance-ai'] as const;

/**
 * The `features` block of `GET /api/auth/session` (ADR-0027 D1). The web
 * compiles the enabled features in at build time. The session gives the
 * parts that the build cannot know:
 * - `manifestHash`: the hash of the resolved Feature Manifest of the API, with
 *   no release hold. The web compares it with its own hash to find a deploy
 *   skew.
 * - `held`: the features that the release holds of this deployment turn off
 *   (ADR-0027 D12). The build holds their code, and the web hides them.
 * - `seats`: the AI seat classes of the signed-in user. Empty when no user is
 *   signed in.
 * - `grantsAllSeats`: true when a bought package grants each seat to each user.
 */
export const sessionFeaturesSchema = z.object({
    manifestHash: z.string(),
    held: z.array(z.string()).default([]),
    seats: z.array(z.enum(SESSION_SEAT_KEYS)),
    grantsAllSeats: z.boolean(),
});

export type SessionFeatures = z.infer<typeof sessionFeaturesSchema>;
